// This function allow to reference async chunks
__webpack_require__.miniCssF = function(chunkId) {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"112":"cab13fca","842":"16a1f0ba","953":"f2ca44d7"}[chunkId] + ".chunk.css";
};